import { render, staticRenderFns } from "./WeightInput.vue?vue&type=template&id=f93f6622&"
import script from "./WeightInput.ts?vue&type=script&lang=js&"
export * from "./WeightInput.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports